import { HTTP } from './helpers/http.js'
import qs from 'qs'

export default {
  create(organizationId, payload) {
    const url = `/api/v1/organizations/${organizationId}/user-filters`
    return HTTP.post(url, payload)
  },

  getAll(organizationId, options = {}) {
    const params = {
      params: options,
      paramsSerializer(params) {
        return qs.stringify(params, { arrayFormat: 'brackets' })
      },
    }

    const url = `/api/v1/organizations/${organizationId}/user-filters`
    return HTTP.get(url, params)
  },

  getById(organizationId, userFilterId) {
    const url = `/api/v1/organizations/${organizationId}/user-filters/${userFilterId}`
    return HTTP.get(url)
  },

  update(organizationId, userFilterId, userFilter) {
    const url = `/api/v1/organizations/${organizationId}/user-filters/${userFilterId}`

    return HTTP.patch(url, userFilter)
  },

  delete(organizationId, userFilterId) {
    const url = `/api/v1/organizations/${organizationId}/user-filters/${userFilterId}`
    return HTTP.delete(url)
  },
}
